<span *ngFor="let starred of stars; let i = index">
  <ng-container *ngIf="starred; else noStar">
    <app-icon class="starred" [icon]="starIcon"></app-icon>
  </ng-container>
  <ng-template #noStar><app-icon class="no-star" [icon]="emptyStarIcon"></app-icon></ng-template>
</span>
